/**
 * Article reading progress: fills a bar under the header based on scroll through [data-article-read].
 * Desktop (990px+) only; bar is hidden via CSS on smaller viewports.
 */
(function () {
  var fill = document.querySelector('.article-read-progress__fill');
  var target = document.querySelector('[data-article-read]');
  if (!fill || !target) return;

  var mq = window.matchMedia('(min-width: 990px)');

  function update() {
    if (!mq.matches) {
      fill.style.width = '0%';
      return;
    }

    var rect = target.getBoundingClientRect();
    var top = window.scrollY + rect.top;
    var height = target.offsetHeight;
    var vh = window.innerHeight;
    var scrollY = window.scrollY;

    var range = height - vh;
    if (range < 1) {
      range = 200;
    }

    var pct = ((scrollY - top) / range) * 100;
    pct = Math.min(100, Math.max(0, pct));
    fill.style.width = pct + '%';
  }

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', update);
  } else if (typeof mq.addListener === 'function') {
    mq.addListener(update);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
})();
